import { UserIsAuthenticated, UserHasValidPassword, UserHasScope } from 'containers/authContainers'
import { setSubroute } from 'store/navbar'
import { injectReducers } from 'store/reducers'
import { setPageTitle } from 'utils/misc'
import { loadingActions } from 'store/loader'
import participants, { fetchCohorts } from '../../../Participants/routes/ParticipantsPage/modules/Participants'
import instrumentReducer, { clearInstrumentTriggers } from '../Instrument/modules/Instrument'
import instruments from './modules/Instruments'
import surveyReducer from '../Instrument/routes/EditSurvey/modules/Survey'
import clinroReducer from '../Instrument/routes/EditClinro/modules/Clinro'
import diaryReducer from '../Instrument/routes/EditDiary/modules/Diary'
import upload from '../Instrument/routes/UploadSurvey/modules/UploadSurvey'
import InstrumentsView from './containers/InstrumentsViewContainer'
import sitesReducer, { fetchSites } from '../../../Sites/routes/SitesPage/modules/Sites'
import { getUserRoleIdByStudy } from '../../../../../../../../utils/misc'
import { USER_ROLE_IDS_WITH_LIMITED_SIDEBAR_ACCESS } from '../../../../../../../../utils/constants'
import { browserHistory } from 'utils/navigation'

export default store => ({
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const { params } = nextState
        const { studyID, studyVersionID } = params

        store.dispatch(setSubroute('instruments'))
        injectReducers(store, {
          instruments,
          instrumentReducer,
          upload,
          surveyEditor: surveyReducer,
          clinroEditor: clinroReducer,
          diaryEditor: diaryReducer,
          participants,
          sites: sitesReducer,
        })

        const { currentStudy } = store.getState().study
        const roleId = getUserRoleIdByStudy(store?.getState()?.user, studyID)
        if (USER_ROLE_IDS_WITH_LIMITED_SIDEBAR_ACCESS.includes(roleId)) {
          store.dispatch(loadingActions.stopLoader(true, 'routeTransition'))
          browserHistory.push(`/studies/${studyID}/${studyVersionID}/compliance`)
        }
        setPageTitle(`Instruments | Study ${studyID} | ${currentStudy.platform_name}`)
        // Unsaved trigger deletes/edits must not stick when reopening the same instrument.
        store.dispatch(clearInstrumentTriggers({ needsHydration: true }))
        store.dispatch(require('./modules/Instruments').actions.fetchInstruments({ studyID }))
        store.dispatch(fetchCohorts(studyID))
        store.dispatch(fetchSites(studyID, false))
        store.dispatch(loadingActions.stopLoader(true, 'routeTransition'))
        cb(null, UserIsAuthenticated(UserHasValidPassword(UserHasScope(['ra'], InstrumentsView, false, studyID))))
      },
      'instruments',
    )
  },
})
